import styled from '@emotion/styled';

export const Container = styled.div<{ $hasFile: boolean; $isError?: boolean }>`
  padding: 24px 60px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  cursor: pointer;
  border-radius: 8px;
  border: 1px solid
    ${(props) =>
      props.$hasFile ? '#007ec3' : props.$isError ? '#8D0909' : '#007ec3'};
`;

export const Row = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const Text = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  color: #7b8794;
`;
